module.exports = __webpack_public_path__ + "static/drzwi-smart-3a6acde3eb23ee7e81a2a973bd1afdee.png";